import { Resource as e } from "@coveo/platform-client";
const i = class i extends e {
  /**
   * Get a preview of the results returned by a query going through a query pipeline.
   *
   * @param {string} pipelineId The unique identifier of the query pipeline.
   * @param {TransformPipelineReviewRequest} transformRequest The transformation to apply to the query pipeline.
   *
   */
  pipelinePreview(t, a) {
    return this.api.post(
      this.buildPath(`${i.baseUrl}/pipelines/${t}`, {
        organizationId: this.api.organizationId
      }),
      a
    );
  }
};
i.baseUrl = "/rest/search/v3/analysis/preview";
let s = i;
export {
  s as PreviewResource
};
//# sourceMappingURL=PreviewResource.js.map
